// Admin dashboard - uses the shared shell, same as every other admin page.
// Cards marked [data-admin-only] are hidden for organization-role users so
// the dashboard mirrors the side-nav (which already filters those rows).
import './site';
import { loadConfig } from '../envConfig';
import { initAdminShell } from './admin/shell';
import { isPlatformAdmin } from './lib/auth';

await loadConfig();
const me = await initAdminShell({ section: 'dashboard', crumb: '' });
if (!isPlatformAdmin(me.role)) {
  // Inline style="display:block" on the cards beats the UA [hidden] rule, so
  // set display:none directly.
  document.querySelectorAll<HTMLElement>('[data-admin-only]').forEach((el) => {
    el.style.display = 'none';
  });
}
